import { render, staticRenderFns } from "./DeepLink.vue?vue&type=template&id=01a2f1c8&scoped=true"
import script from "./DeepLink.vue?vue&type=script&lang=ts"
export * from "./DeepLink.vue?vue&type=script&lang=ts"
import style0 from "./DeepLink.vue?vue&type=style&index=0&id=01a2f1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2f1c8",
  null
  
)

export default component.exports